"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _helpers = require("../../../helpers");

var _reactRedux = require("react-redux");

var _InfoIcon = _interopRequireDefault(require("../InfoIcon"));

var _EyeIcon = _interopRequireDefault(require("./EyeIcon"));

var _index = require("../../../../index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GroupedTable = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(GroupedTable, _React$Component);

  function GroupedTable() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      sortColumn: 'score',
      sortDirection: 'descending'
    });

    _defineProperty(_assertThisInitialized(_this), "handleSortChange", function (clickedColumn) {
      return function () {
        return (0, _helpers.sortChangeHandler)(clickedColumn, _assertThisInitialized(_this));
      };
    });

    _defineProperty(_assertThisInitialized(_this), "sort", function (a, b) {
      return (0, _helpers.sortData)(a, b, _assertThisInitialized(_this));
    });

    return _this;
  }

  var _proto = GroupedTable.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        communityColours = _this$props.communityColours,
        selectedPersonas = _this$props.selectedPersonas,
        handleSelectPersona = _this$props.handleSelectPersona,
        hideUnselectedPersonas = _this$props.hideUnselectedPersonas,
        handleHideUnselectedPersonas = _this$props.handleHideUnselectedPersonas,
        maxScore = _this$props.maxScore,
        dataForRows = _this$props.dataForRows,
        isFetching = _this$props.isFetching,
        displaySegmentIds = _this$props.displaySegmentIds,
        pluralView = _this$props.pluralView;
    var _this$state = this.state,
        sortColumn = _this$state.sortColumn,
        sortDirection = _this$state.sortDirection;
    var tooSmallSample = /*#__PURE__*/React.createElement("span", {
      className: "table__sample-small"
    }, "One or more data sources fall below the reportable threshold.");

    if (dataForRows && dataForRows.length) {
      var TableHeader = /*#__PURE__*/React.createElement(_semanticUiReact.Table.Header, {
        className: "data-workflow-table__header"
      }, /*#__PURE__*/React.createElement(_semanticUiReact.Table.Row, null, /*#__PURE__*/React.createElement(_semanticUiReact.Table.HeaderCell, {
        className: "data-workflow-table__lead-cell",
        sorted: sortColumn === 'segmentId' ? sortDirection : null,
        onClick: this.handleSortChange('segmentId')
      }, /*#__PURE__*/React.createElement(_EyeIcon["default"], {
        hideUnselectedPersonas: hideUnselectedPersonas,
        handleHideUnselectedPersonas: handleHideUnselectedPersonas
      }), "Persona"), /*#__PURE__*/React.createElement(_semanticUiReact.Table.HeaderCell, {
        sorted: sortColumn === 'score' ? sortDirection : null,
        onClick: this.handleSortChange('score')
      }, /*#__PURE__*/React.createElement(_InfoIcon["default"], null, /*#__PURE__*/React.createElement("p", null, "The score is calculated using a proprietary method for combining the index and share values of individual attributes. It is an indicative measure only, but can be a useful means of identifying ", pluralView, " based on a combination of attributes."), /*#__PURE__*/React.createElement("p", null, "Complementary attributes from the same category are treated jointly rather than independently, and account is taken of the fact that different attributes may be drawn from different data sets.")), "Combined Affinity Score")));
      var Rows = dataForRows.sort(this.sort);

      if (hideUnselectedPersonas === true) {
        Rows = Rows.filter(function (row) {
          return selectedPersonas.find(function (persona) {
            return parseInt(persona.id) === parseInt(row.segmentId);
          });
        });
      }

      Rows = Rows.map(function (record, key) {
        return /*#__PURE__*/React.createElement(_semanticUiReact.Table.Row, {
          className: "data-workflow-table__row",
          key: key
        }, /*#__PURE__*/React.createElement(_semanticUiReact.Table.Cell, {
          className: "data-workflow-table__lead-cell",
          collapsing: true
        }, /*#__PURE__*/React.createElement(_semanticUiReact.Checkbox, {
          className: "data-workflow-table__checkbox",
          checked: selectedPersonas.filter(function (persona) {
            return parseInt(persona.id) === parseInt(record.segmentId);
          }).length > 0 ? true : false,
          onClick: function onClick() {
            return handleSelectPersona(record.segmentId, record.segmentLabel);
          },
          value: record.segmentId,
          label: "\n                  " + (displaySegmentIds ? record.segmentId : '') + " " + record.segmentLabel + "\n                "
        })), /*#__PURE__*/React.createElement(_semanticUiReact.Table.Cell, null, record.belowSample ? tooSmallSample : /*#__PURE__*/React.createElement("div", {
          className: "data-workflow-table__index-bar",
          style: {
            width: record.score / maxScore * 100 + '%',
            backgroundColor: communityColours[Math.floor(record.segmentId / 100) * 100]
          }
        })));
      });

      if (isFetching) {
        return /*#__PURE__*/React.createElement(_index.LoadingIndicator, null);
      }

      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_semanticUiReact.Table, {
        sortable: true,
        stackable: true,
        striped: true,
        className: "grouped-persona-table"
      }, TableHeader, /*#__PURE__*/React.createElement(_semanticUiReact.Table.Body, null, Rows)));
    } else {
      return /*#__PURE__*/React.createElement("h3", {
        className: "data-workflow-table__no-results"
      }, "Select answers to the questions on the left to view data");
    }
  };

  return GroupedTable;
}(React.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    displaySegmentIds: state.options.displaySegmentIds.value,
    pluralView: state.audienceView.view.textPlural
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, undefined)(GroupedTable);

exports["default"] = _default;